<template>
    <div class="grid lg:grid-cols-4 pt-32 lg:pt-0">
        <slot />
    </div>
</template>

<script lang="ts" setup></script>
